/* Skeena Couture cart drawer: reservation countdown (replaces the former UpCart announcement timer).
   The end time is kept in sessionStorage so it survives the drawer re-rendering and page changes;
   when it has run out, a fresh countdown starts the next time the drawer is rendered. */
(function () {
  if (window.customElements.get('cart-reservation-timer')) return;

  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      const minutes = parseInt(this.getAttribute('minutes') || '10', 10);
      const key = 'skeena-cart-reservation-end';
      const now = Date.now();
      let end = 0;
      try { end = parseInt(window.sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
      if (!end || end <= now) {
        end = now + minutes * 60 * 1000;
        try { window.sessionStorage.setItem(key, String(end)); } catch (e) { /* storage unavailable */ }
      }
      this._end = end;
      this._tick();
      this._interval = window.setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this._interval);
    }

    _tick() {
      const target = this.querySelector('[data-timer]');
      if (!target) return;
      const remaining = Math.max(0, Math.round((this._end - Date.now()) / 1000));
      const m = String(Math.floor(remaining / 60)).padStart(2, '0');
      const s = String(remaining % 60).padStart(2, '0');
      target.textContent = m + ':' + s;
      if (remaining === 0) window.clearInterval(this._interval);
    }
  }

  window.customElements.define('cart-reservation-timer', CartReservationTimer);
})();
